import type { ChartValues } from '@/types/chart';

export function getLatestDataPoint(data: ChartValues[]) {
  if (!data || data.length === 0) {
    return null;
  }

  const lastDataPoints = data.map((d) => d.data[d.data.length - 1]);

  return lastDataPoints;
}
